module.exports = __webpack_public_path__ + "static/img/dark.d0efa020.svg";